import styled, { css } from 'styled-components';
import { BonanzaPromoStatus } from '@/modules/promotions/helpers';
import { device, typography } from '@/styles/helpers';

interface IScStatusLabelProps {
  status: BonanzaPromoStatus;
}

export const ScStatusLabel = styled.p<IScStatusLabelProps>`
  position: absolute;
  z-index: 2;

  img {
    display: block;
  }

  span {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -30%);
    text-align: center;
    white-space: break-spaces;
    ${typography.body2bold}
    color: ${({ theme }) => theme.blackColor};
    width: 100px;
  }

  ${({ status }) =>
    status === BonanzaPromoStatus.UNLOGGED &&
    css`
      top: 30px;
      right: 160px;
      @media (${device.mobile}) {
        top: 10px;
        right: 5px;
        span {
          width: 70px;
        }
        img {
          width: 102px;
          height: 102px;
        }
      }
    `}

  ${({ status }) =>
    status === BonanzaPromoStatus.PROMO_LOCKED &&
    css`
      top: 25px;
      right: 140px;
      @media (${device.mobile}) {
        top: 20px;
        right: -15px;
      }
    `}

  @media (${device.mobile}) {
    span {
      ${typography.caption2regular};
      font-weight: 700;
      font-size: 12px
    }
  }
`;
